import { Typography } from '@mui/material';

export const FieldDesc = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={'opacity-50 mb-2 ' + className}>
      <Typography variant="body2">{children} </Typography>
    </div>
  );
};
